
import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "./../../../provider/CommonContext";
import { useNavigate } from "react-router-dom";
import "./Insights.css";
import whatsapp from "../../../../src/Images/New_Home/whatsapp.png";
import telegram from "../../../../src/Images/New_Home/telegram.png";
import Calender from "../../Market/Calender/Calender"
function Insights() {
    let navigate = useNavigate();
    const [data, setData] = useState([]);
    const [dataCorp, setDataCorp] = useState([]);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);
    const [filteredNewsData, setFilteredNewsData] = useState([]);
    const handleClose = () => setShow(false);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("day");
    const [type, settype] = useState('');
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrlNew = BaseURL + "Eventcal";
        fetch(`${getUrlNew}/week`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
            })
            .catch((error) => {
            });

    }, []);

    const routeEventTracker = () => {
        let path = `/market/event-tracker`;
        navigate(path);
    }

    const routeContactUs = () => {
        let path = `/Contact`;
        navigate(path)
    }

    return (
        <div>

            <div class="home-new-main">


                <section class="insight-section">
                    <div class="container">
                        <h2 class="section-heading center" >
                            RESEARCH AND INSIGHTS
                        </h2>
                        <div class="row justify-content-center text-center">
                            <div class="col-lg-6">
                                <div class="back">
                                    <p class="joins">Join Our Premium Research</p>
                                    <div class="greenbox ">
                                        <div class="one">
                                            <p class="innertext">Whatsapp Group</p>
                                            <button class="contact-us" onClick={routeContactUs}>Contact Us</button>
                                        </div>
                                        <div class="two">
                                            <img src={whatsapp} class="img-fluid" onClick={routeContactUs} alt="whatsapp" />
                                        </div>
                                    </div>
                                </div>
                                <div class="back">
                                    <div class="bluebox martop ">
                                        <div class="one">
                                            <p class="innertextwo">Telegram Group</p>
                                            <button class="contact-us_tel" onClick={routeContactUs}>Contact Us</button>
                                        </div>
                                        <div class="two">
                                            <img src={telegram} class="img-fluid" onClick={routeContactUs} alt="telegram" />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-lg-6">
                                <div class="backtwo ">
                                    <p class="joins">Stock insight</p>
                                    <div class="backblue shadow">
                                        <div className="insightMainDiv">
                                            {data && data.map((item, index) => (
                                                <>
                                                    {index <= 5 ? (<div className={(item.corptype === "Dividend") ? "color1 cal-item" : (item.corptype === "Bonus") ? "color2 cal-item" : (item.corptype === "Split") ? "color3 cal-item" : (item.corptype === "BuyBack") ? "color4 cal-item" : (item.corptype === "Rights") ? "color5 cal-item" : (item.corptype === "AGM") ? "color6 cal-item" : (item.corptype === "Board Meeting") ? "color7 cal-item" : (item.corptype === "EGM") ? "color8 cal-item" : (item.corptype === "Book Closure") ? "color9 cal-item" : (item.corptype === "Result") ? "color10 cal-item" : ''}>
                                                        <div class="Insi-num">{item.totalcount}</div>
                                                        <p className="InsiFont">{item.corptype}</p>
                                                    </div>) : ''}
                                                </>
                                            ))}
                                        </div>
                                        <button class="viewmore" onClick={routeEventTracker}>View More</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Insights;




